import React from 'react';
import Avatar from '../../common/Avatar';
import './RoleCard.scss';

const ROLE_COLORS = {
  Frontend: '#3b82f6',
  '整合': '#8b5cf6',
  Backend: '#f59e0b',
  QA: '#10b981',
};

const RoleCard = ({ role, assigneeId, assigneeName, assigneeAvatar, items, onClick, onDelete }) => {
  const totalCount = items.length;
  const doneCount = items.filter((i) => i.is_completed).length;
  const remainingCount = totalCount - doneCount;
  const percent = totalCount > 0 ? Math.round((doneCount / totalCount) * 100) : 0;

  const completedActualHours = items
    .filter((i) => i.is_completed)
    .reduce((s, i) => s + (parseFloat(i.actual_hours) || 0), 0);
  const remainingEstHours = items
    .filter((i) => !i.is_completed)
    .reduce((s, i) => s + (parseFloat(i.estimated_hours) || 0), 0);

  const badgeColor = ROLE_COLORS[role] || '#667eea';

  return (
    <div className="dl-role-card" onClick={onClick}>
      {onDelete && (
        <button
          className="dl-role-card-delete"
          onClick={(e) => { e.stopPropagation(); onDelete(); }}
          title="刪除角色"
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M2 2l8 8M10 2l-8 8" strokeLinecap="round" />
          </svg>
        </button>
      )}
      <div className="dl-role-card-header">
        <span className="dl-role-card-badge" style={{ backgroundColor: badgeColor }}>
          {role}
        </span>
        {assigneeId ? (
          <Avatar avatarUrl={assigneeAvatar} name={assigneeName || '?'} size="xsmall" />
        ) : (
          <span className="dl-role-card-unassigned">未指派</span>
        )}
      </div>

      <div className="dl-role-card-body">
        <div className="dl-role-card-stat">
          {remainingCount > 0 ? (
            <span>{remainingCount} 項未完成</span>
          ) : totalCount > 0 ? (
            <span className="all-done">全部完成</span>
          ) : (
            <span className="no-items">尚無項目</span>
          )}
        </div>

        <div className="dl-role-card-hours">
          <span className="actual">{completedActualHours}h 實際</span>
          <span className="sep"> / </span>
          <span className="remaining">{remainingEstHours}h 剩餘預估</span>
        </div>
      </div>

      {totalCount > 0 && (
        <div className="dl-role-card-progress">
          <div className="dl-role-card-bar">
            <div className="dl-role-card-bar-fill" style={{ width: `${percent}%` }} />
          </div>
          <span className="dl-role-card-percent">{percent}%</span>
        </div>
      )}
    </div>
  );
};

export { ROLE_COLORS };
export default RoleCard;
